import { Component } from '@angular/core';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss',],
})
export class ProcessComponent{

  constructor() { }

  processSteps = [
    {
      title: 'Find the right car',
      description: 'Choose from a wide range of PPP Assured cars with 300+ quality checks.',
      image:'assets/images/landing-page/findtherightcar.svg',
    },
    {
      title: 'Get online approval',
      description: ' Submit your documents & get online eligibility approval.',
      image:'assets/images/landing-page/onlineapproval.svg',
    },
    {
      title: 'Drive worry free',
      description: 'Simply drive and enjoy the experience, just like you own it.',
      image:'assets/images/landing-page/driveworryfree.svg',
    },
  ];
}
